<template>
  <div class="house">
    <div class="rightmouse"
         :style="{ top: rightMouseTop + 'px', left: rightMouseLeft + 'px' ,opacity : rightMouseFlag ? '1' : '0'}">
      <p>© 图片版权保护</p>
    </div>
    <div class="househeader">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>个人资源库</el-breadcrumb-item>
          <el-breadcrumb-item>未整理资源</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main"
         v-loading="isRefresh">
      <div class="head disflex">
        <div class="left">
          <h4 style="font-size:18px;margin-left:5px;">未整理资源<span style="font-size:13px;font-weight:300;">（{{nnclutteredPic || 0}}张）</span></h4>
        </div>

        <div class="rightpic disflex">
          <!-- <el-button @click.stop = "plDelete" :style="{background:choosePic.length > 0?'#F56C6C':'rgba(163,163,163,1)'}" :disabled="choosePic.length < 1">
            <i class="delete"></i>
            <span class="text">删除</span>
          </el-button> -->
          <p @click="picSortFlag = true"
             :class="picSortFlag === true ? isSimple ? 'simpleactive' : 'active' : ''">按天排序</p>
          <div>|</div>
          <p @click="picSortFlag = false"
             :class="picSortFlag === true ? '' : isSimple ? 'simpleactive' : 'active'">按月排序</p>
        </div>
      </div>

      <div v-loading="isDelete"
           class="piclist"
           style="display:flex;">
        <div style="width:calc(100% - 452px);min-height:805px;">
          <div v-if="choosePic.length > 0"
               @click.stop="plDelete"
               class="del">
            <div style="text-align:center;">
              <img src="@/assets/personpic/alldel.png"
                   alt="">
              <p style="margin-left:3px;">删除</p>
            </div>
          </div>
          <template v-if="picSortFlag">
            <div class="time"
                 v-for="(e,i) in testList"
                 :key="i">
              <el-checkbox @change="choosePicChange(testList[i].time420,e.picList,i)"
                           :indeterminate="testList[i].indeterminate"
                           v-model="testList[i].time420">{{e.mycreateAt}}</el-checkbox>
              <div class="yuan"></div>
              <div class="xian"></div>

              <div class="datepic">
                <section>

                  <div :class="choosePic.indexOf(item.id) === -1 ? 'img-wrapper':isSimple ? 'img-wrapper simpleimgborder' : 'img-wrapper imgborder'"
                       @click="choosePicClick(item.id,i)"
                       v-for="(item, index) in e.picList"
                       :key="index">
                    <img class="img"
                         @contextmenu.prevent="rightShow($event)"
                         ondragstart="return false;"
                         v-if="item.type=='pic'"
                         :src="item.src" />
                    <video style="height:150px;" 
                        
                          @contextmenu.prevent="rightShow($event)"
                          v-if="item.type === 'video'"
                          ondragstart="return false;" 
                          :src="item.src">
                    </video>
                    <!-- 播放 -->
                    <div v-if="item.type == 'video'" class="play">
                      <img src="@/assets/piclist/playb.png" alt />
                    </div>
                    <!-- 修改图片信息 -->
                    <el-tooltip class="item"
                                effect="dark"
                                content="修改资源说明"
                                placement="top">
                      <div @click.stop="openChangeDesc(item)"
                           class="changedesc">
                        <img src="@/assets/sreenpic/desc.png"
                             alt="">
                      </div>
                    </el-tooltip>

                    <!-- 修改图片信息 -->
                    <el-tooltip class="item"
                                effect="dark"
                                content="查看资源"
                                placement="top">
                      <div @click.stop="seePic(item,index,i)"
                           class="seepic">
                        <img src="@/assets/solicitationactivities/see.png"
                             alt="">
                      </div>
                    </el-tooltip>

                    <div v-if="choosePic.indexOf(item.id) !== -1"
                         class="delete">
                      <img :src="isSimple ? require('@/assets/personpic/simplegou.png') : require('@/assets/personpic/gou.png')"
                           alt="">
                    </div>
                  </div>

                </section>
              </div>
            </div>

          </template>

          <template v-if="!picSortFlag">
            <div class="time"
                 v-for="(e,i) in testListMonth"
                 :key="i">
              <el-checkbox @change="choosePicChange(testList[i].time420,e.picList,i)"
                           :indeterminate="testList[i].indeterminate"
                           v-model="testList[i].time420">{{e.mycreateAtMonth}}</el-checkbox>
              <div class="yuan"></div>
              <div class="xian"
                   style="left:99px;"></div>

              <div class="datepic">
                <section>

                  <div :class="choosePic.indexOf(item.id) === -1 ? 'img-wrapper':isSimple ? 'img-wrapper simpleimgborder' : 'img-wrapper imgborder'"
                       @click="choosePicClick(item.id,i)"
                       v-for="(item, index) in e.picList"
                       :key="index">
                    <img class="img"
                         @contextmenu.prevent="rightShow($event)"
                         ondragstart="return false;"
                         v-if="item.type=='pic'"
                         :src="item.src" />
                    <video style="height:150px;" 
                          muted autoplay
                          @contextmenu.prevent="rightShow($event)"
                          v-if="item.type === 'video'"
                          ondragstart="return false;" 
                          :src="item.src">
                    </video>
                    <!-- 播放 -->
                    <div v-if="item.type == 'video'" class="play">
                      <img src="@/assets/piclist/playb.png" alt />
                    </div>
                    <div v-if="choosePic.indexOf(item.id) !== -1"
                         class="delete">
                      <img :src="isSimple ? require('@/assets/personpic/simplegou.png') : require('@/assets/personpic/gou.png')"
                           alt="">
                    </div>
                  </div>

                </section>
              </div>
            </div>
          </template>

          <template v-if="testList.length === 0">
            <div class="nopic">
              <img src="@/assets/piclist/nonr.png"
                   alt />
            </div>
          </template>
          <img v-if="showLoading"
               width="200px"
               style="margin-left:40%"
               src="@/assets/blue-preloader.gif"
               alt />
        </div>

        <div :class="picinfClass">
          <div class="curtain">
            <!-- <div class="disflex"> -->
            <h4 @click="changeUploadMode"
                :class="uploadMode === 0? isCustom ? custom == 'xugong' ? 'xgactive' : 'wcactive' : isSimple ? 'simpleactive' : 'active':''">创建新资源集</h4>
            <h4 @click="changeUploadMode"
                :class="uploadMode === 1? isCustom ? custom == 'xugong' ? 'xgactive' : 'wcactive' : isSimple ? 'simpleactive' : 'active':''">归档到资源集</h4>
            <!-- </div> -->

          </div>

          <div v-if="uploadMode === 0"
               class="nr">
            <el-form :model="atlasForm"
                     style="margin-top:-15px;"
                     :rules="rules"
                     ref="ruleForm"
                     class="demo-ruleForm">
              <el-form-item prop="libId">
                <!-- 归属资源库 -->
                <div class="inputlist">
                  <p>归属资源库</p>
                  <el-cascader
                      style="width: 100%;margin-top:5px;"
                      v-model="atlasForm.libId"
                      :options="options"></el-cascader>
                  <!-- <el-select class="elinput"
                             :disabled="isSave"
                             style="width:100%;margin-top:5px;"
                             v-model="atlasForm.libId"
                             placeholder="请选择">
                    <el-option v-for="item in options"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value"
                               v-html="'<span style=color:#303030;>'+item.label+'</span>'"></el-option>
                  </el-select> -->
                </div>
              </el-form-item>

              <!-- 资源集名称 -->
              <el-form-item prop="name">
                <div class="inputlist">
                  <p>资源集名称</p>
                  <el-input class="elinput"
                            :disabled="isSave"
                            style="width:100%;margin-top:5px;"
                            v-model="atlasForm.name"
                            placeholder="请输入资源集名称"></el-input>
                </div>
              </el-form-item>

              <!-- 相册说明 -->
              <el-form-item prop="desc">
                <div class="inputlist">
                  <p>资源集说明</p>
                  <el-input type="textarea"
                            :autosize="{ minRows,maxRows}"
                            style="width:100%;margin-top:5px;"
                            placeholder="请输入资源集说明"
                            v-model="atlasForm.desc"
                            :disabled="isSave"></el-input>
                </div>
              </el-form-item>

              <!-- 可见性 -->
              <el-form-item prop="status">
                <div class="inputlist">
                  <p>可见性</p>
                  <el-radio-group :disabled="isSave || statusFlag"
                                  style="margin-top:5px;"
                                  :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                                  v-model="atlasForm.status"
                                  size="medium">
                    <el-radio-button label="0">私密</el-radio-button>
                    <el-radio-button label="1">公开</el-radio-button>
                  </el-radio-group>
                  <!-- <el-select class="elinput" :disabled="isSave" style="width:100%;" v-model="atlasForm.status" placeholder="请选择">
                    <el-option
                      v-for="item in visibilityList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select> -->
                </div>
              </el-form-item>

              <div class="inputlist">
                <p>已选中资源数：<span>{{choosePic.length}}</span></p>
              </div>

              <div style="width:120px;"
                   class="btn">
                <el-button :disabled="isSave"
                           :style="{'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                           @click.stop="save('ruleForm')">
                  <i class="save"></i>
                  <span class="text">保存</span>
                </el-button>
                <!-- <el-button @click.stop="dev">
                  <i class="push"></i>
                  <span class="text">保存并推送</span>
                </el-button> -->

              </div>

            </el-form>
          </div>

          <div v-if="uploadMode === 1"
               class="nr">
            <el-form :model="atlasForm"
                     :rules="rules"
                     ref="ruleForm"
                     class="demo-ruleForm">
              <el-form-item prop="libId">
                <!-- 归属资源库 -->
                <div class="inputlist">
                  <p>指定图集</p>
                  <el-input class="elinput"
                            style="width:100%;"
                            v-model="myselect"
                            placeholder="请输入关键字进行筛选"
                            @input="myLibChange"
                            :disabled="isSave">
                    <!-- <el-option
                      v-for="item in myAtlas"
                      :key="item.value.id"
                      :label="item.label"
                      :value="item.value"
                    ></el-option> -->
                  </el-input>
                </div>
              </el-form-item>

              <el-table :data="myAtlas"
                        stripe
                        height="400"
                        @row-click="rowClick"
                        highlight-current-row
                        style="width: 100%;overflow-y: auto;">
                <el-table-column prop="name"
                                 show-overflow-tooltip
                                 label="资源集名">
                </el-table-column>
                <el-table-column prop="date"
                                 label="创建时间">
                </el-table-column>

              </el-table>

              <div style="margin-top:20px;"
                   class="inputlist">
                <p>已选中资源数：<span>{{choosePic.length}}</span></p>
              </div>

              <div style="width:120px;"
                   class="btn">
                <el-button :disabled="isSave"
                           :style="{'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                           @click.stop="save('ruleForm')">
                  <i class="save"></i>
                  <span class="text">保存</span>
                </el-button>
                <!-- <el-button @click.stop = "dev">
                <i class="push"></i>
                <span class="text">保存并推送</span>
              </el-button> -->

              </div>
            </el-form>
          </div>
        </div>
      </div>

    </div>

    <!-- 查看未整理图片 -->
    <picview :dialogVisible="picdialogVisible"
             @handleClose="handleClosepic"
             :passChoose='passChoose'
             :picList='inPicList'></picview>

    <changedescdialog :message="message"
                      :dialogVisible="descdialogVisible"
                      @handleClose="deschandleClose"
                      @changeDesc="changeDesc"></changedescdialog>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { searchAtlas } from '@/api/search'
import { listUnclutteredPicture, deletePicture, updatePicture, removePicturePic, bindingAtlas } from '@/api/picture'
import { listUnclutteredVideo } from '@/api/video'
import { getFileInfoById } from "@/api/file"


import { formatConversion } from '@/plugins/getdate'
import { listLib } from "@/api/lib";
import { picPrefix } from "@/constants/piccommon";
import { addAtlas, updateAtlas } from "@/api/atlas";
import { listPeopleFaceByPeopleId } from "@/api/peopleFace";
import { listPeople, setPass, markPeople, getPeopleConstant, mergePeople } from "@/api/people";
import { powersObj, allowLib } from "@/constants/powers";

import { changedescdialog } from '@/components/index'

import picview from '@/components/picView/picView'
export default {
  inject: ['reload'],
  components: { changedescdialog, picview },
  computed: {
    ...mapGetters(["createUid"]),
  },
  data () {
    return {


      //可见性权限
      statusFlag: false,

      //图集信息
      atlasInfo: null,

      //根据分辨率判断长度
      documentHeight: 0,
      minRows: 8,
      maxRows: 12,


      //权限
      powersObj,
      allowLib,


      //批量操作
      plFlag: true,



      //分辨率
      row: 1,
      widthWithUP: '',
      displayResolution: 0,

      //图集间距
      atlasMargin: '',

      //侧边栏是否收起
      isAside: this.bus.val,

      picPrefix,


      //选中的图片
      choosePic: [],


      //当日所有的图片
      testList: [],
      //当月所有的图片
      testListMonth: [],

      //存储所有未整理图片
      allPicList: [],

      atlasId: '',
      libId: '',
      isSave: false,

      //是按天还是按月排序   
      picSortFlag: true,
      picinfClass: "picinf",

      //时间排序 
      sortFlag: true,

      //未整理图片的个数
      nnclutteredPic: "",

      currentPage: 0,

      //显示我的资源集还是未整理图片   0为图集
      isPic: 0,

      //分页
      total: 0,
      pageSize: 15,
      page: 0,
      totalPic: 0,
      pageSizePic: 10,
      pagePic: 0,
      orderByTime: 0,

      //所有图集
      picList: [],

      faceMarginTop: '',

      isRefresh: false,



      visibility: "公开",
      options: [],
      visibilityList: [
        {
          value: "1",
          label: "公开"
        },
        {
          value: "0",
          label: "私密"
        }
      ],
      atlasForm: {
        libId: "",
        name: "",
        desc: "",
        status: '',
        sourceType: "0",
        indexpicId: "0",
        createUid: this.createUid,
      },
      rules: {
        name: [{ required: true, message: "请输入资源集名称", trigger: "blur" }],
        desc: [{ min: 0, max: 200, message: '长度在 200 个字符以内', trigger: 'blur' }],
        libId: [
          { required: true, message: "请选择归属图库", trigger: "change" }
        ],
        status: [{ required: true, message: "请选择可见性", trigger: "change" }]
      },
      pic: {
        id: 4278,
        name: '',
        src: '',
      },

      //归档图集
      uploadMode: 0,
      myselect: '',
      myAtlas: [],
      myLibId: 0,
      myAtlasId: 0,
      isReLoad: false,
      isDelete: false,
      alreadyPicLength: 0,

      //查看图片相关
      atlasName: '新建资源集',

      //图片说明
      descdialogVisible: false,
      message: '',

      //查看未整理图片相关
      picdialogVisible: false,
      passChoose: {},
      inPicList: [],
      showLoading: false,
      passFlag: true,

      //鼠标右击
      rightMouseTop: 0,
      rightMouseLeft: 0,
      rightMouseFlag: false,
    };
  },
  methods: {


    //图片右击
    rightShow (e) {
      this.rightMouseLeft = e.clientX
      this.rightMouseTop = e.clientY
      setTimeout(() => {
        this.rightMouseFlag = true
      }, 200);
      setTimeout(() => {
        this.rightMouseFlag = false
      }, 2000);
      // this.$message('版权所有')
    },

    //修改图片说明
    changeDesc (val) {
      this.updatePictureAsync(val)
      this.descdialogVisible = false
    },
    deschandleClose () {
      this.descdialogVisible = false
    },
    openChangeDesc (val) {
      // console.log(val)
      this.message = val
      this.listLibAsync()
      this.descdialogVisible = true
    },
    //修改图片说明
    async updatePictureAsync (val) {
      let { status, data, message, errors } = await updatePicture(val);
      if (status) {
        this.$message.success("修改成功！")
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //查看未整理图片
    seePic(e, ci, i) {
      console.log(e,ci,i);
      e.createAtMy = e.mycreateAt
      if (e.fileInfo.savepath) {
        e.format = e.fileInfo.savepath.substring(e.fileInfo.savepath.length - 3)
      } else {
        e.format = '暂无'
      }
      // e.labels=['风景','运动员','环境','劳作','亲子活动','开会','抗洪抢险','剪裁']
      this.passChoose = e
      this.passChoose.myId = ci
      this.inPicList = this.testList[i].picList
      for (let z = 0; z < this.inPicList.length; z++) {
        this.inPicList[z].myId = z
      }
      this.picdialogVisible = true
    },
    handleClosepic () {
      this.picdialogVisible = false
    },


    //查看图集信息
    seeAtlas (e) {
      this.atlasName = '图集信息'
      this.ruleForm = {
        name: e.name,
        region: e.libId || 0,
        desc: e.desc,
        status: e.status,
        id: e.id,
        indexpicId: e.indexpicId,
        sourceType: e.sourceType,
      }
      this.dialogVisiblePutIn = true
      // console.log(e)
    },

    //筛选内容
    picClick (i, id) {
      this.belongPicFlag = i;
      this.picId = id;
      this.searchClick()
    },

    //状态筛选
    statusClick (i, id) {
      this.statusPicFlag = i;
      this.statusId = id;
      this.searchClick()
    },

    searchClick () {
      if (this.warehousingTime) {
        if (this.warehousingTime[0]) {
          this.timeStart = this.warehousingTime[0] / 1000;
          this.timeEnd = this.warehousingTime[1] / 1000;
        }
      } else {
        this.timeStart = "";
        this.timeEnd = "";
      }

      if (this.belongPicFlag === 0) {
        this.picId = "";
      }
      this.pagePic = 0;
      this.page = 0;
      this.orderByTime = 0;
      let params = {
        createUid: this.createUid,
        keyword: this.selectInput,
        libId: this.picId,
        timeStart: this.timeStart,
        timeEnd: this.timeEnd,
        page: this.page,
        pageSize: this.pageSize,
        orderByTime: this.orderByTime,
        status: this.statusId
      };
      this.searchAtlasAsync(params)
    },

    myAtlasClick () {
      this.isPic = 0
      this.uploadMode = 0
      this.choosePic = []
    },

    changeUploadMode () {
      if (this.uploadMode === 0) {

        this.uploadMode = 1
      } else {
        this.uploadMode = 0
      }
    },
    rowClick (row) {
      // this.myLibId = row.libId
      this.myAtlasId = row.atlasId
    },
    myLibChange () {
      // console.log(this.myselect)
      if (!this.myselect) {
        this.myAtlas = []
        this.mySearchAtlasAsync({ pageSize: 50, page: 0, createUid: this.createUid })
      }
      if (this.myselect.length >= 2) {
        this.myAtlas = []
        this.mySearchAtlasAsync({ keyword: this.myselect, pageSize: 50, page: 0, createUid: this.createUid })
      }
      // this.myLibId = i.libId
      // this.myAtlasId = i.id
    },

    async mySearchAtlasAsync (val) {
      let { status, data, message } = await searchAtlas(val);
      if (status) {
        for (let i = 0; i < data.length; i++) {
          this.myAtlas.push({
            name: '[' + (data[i].libInfo ? data[i].libInfo.name : '暂无') + '] ' + data[i].name,
            date: formatConversion(data[i].createAt.toString()),
            libId: data[i].libId,
            atlasId: data[i].id

          });

        }
        // this.myAtlasId = this.myAtlas[0].label;
      } else {
      }
    },


    //新增资源集
    addAtlasClick () {
      this.atlasName = '新建资源集'
      this.dialogVisiblePutIn = true;
      this.ruleForm = {
        name: "",
        region: "",
        desc: "",
        status: "0"
      }
      this.$refs["addRuleForm"].resetFields();
      this.listLibAsync()
    },
    handleClosePutIn () {
      this.ruleForm = {
        name: "",
        region: "",
        desc: "",
        status: "0"
      }
      this.$refs["addRuleForm"].resetFields();
      this.dialogVisiblePutIn = false;
    },
    dev () {
      this.$message("正在开发中……")
    },

    subPutIn () {
      this.$refs["addRuleForm"].validate(valid => {
        if (valid) {
          this.dialogLoading = true;
          if (this.atlasName == '新建资源集') {
            let data = {
              name: this.ruleForm.name,
              desc: this.ruleForm.desc,
              libId: this.ruleForm.region,
              status: this.ruleForm.status,
              sourceType: "0",
              createUid: this.createUid,
              indexpicId: "0"
            };
            this.addAtlasAsync(data);
            this.dialogVisiblePutIn = false;
            setTimeout(() => {
              this.$router.push({
                name: "pictureUpload", //跳转的路径
                params: {
                  atlas: this.atlasInfo
                }
              });
            }, 500);
          } else {
            this.dialogVisiblePutIn = false;
            let data = {
              name: this.ruleForm.name,
              desc: this.ruleForm.desc,
              libId: this.ruleForm.region,
              status: this.ruleForm.status,
              createUid: this.createUid,
              id: this.ruleForm.id,
              indexpicId: this.ruleForm.indexpicId,
              sourceType: this.ruleForm.sourceType,
            };
            this.updateAtlasAsync(data)
          }

        } else {
          return false;
        }
      });
    },



    //刷新表格
    refresh () {

      this.isRefresh = true

      this.choosePic = []

      //获取未整理图片
      this.listUnclutteredPictureAsync({ uid: this.createUid })

      //获取图库列表
      this.listLibAsync()

      this.displayResolution = document.documentElement.clientWidth;

      setInterval(() => {
        this.judgRes()
      }, 666);
      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },





    //选择图片
    choosePicClick (id, i) {

      if (this.choosePic.indexOf(id) === -1) {
        this.choosePic.push(id)
        this.testList[i].indeterminate = true
        this.testList[i].chooseFlag++
        if (this.testList[i].chooseFlag === this.testList[i].picList.length) {
          this.testList[i].time420 = true
          this.testList[i].indeterminate = false
        }
      } else {
        this.choosePic.splice(this.choosePic.indexOf(id), 1)
        this.testList[i].chooseFlag--

        if (this.testList[i].chooseFlag === 0) {
          this.testList[i].indeterminate = false
          this.testList[i].time420 = false
        } else {
          this.testList[i].indeterminate = true
          this.testList[i].time420 = false
        }
      }
    },

    //选择改变的图片
    choosePicChange (check, pl, index) {
      this.testList[index].indeterminate = false
      if (check) {
        pl.forEach((e, i) => {
          if (this.choosePic.indexOf(e.id) === -1) {
            this.choosePic.push(e.id)
            this.testList[index].chooseFlag++
          }
        })
      } else {
        pl.forEach((e, i) => {
          if (this.choosePic.indexOf(e.id) !== -1) {
            this.choosePic.splice(this.choosePic.indexOf(e.id), 1)
            this.testList[index].chooseFlag--
          }
        })
      }
    },



    //图片保存
    save (formName) {
      // console.log(this.choosePic)

      if (this.testList.length === 0 || this.testListMonth.length === 0) {
        this.$message.warning("暂无内容可选择！")
        return
      }

      if (this.choosePic.length === 0) {
        this.$message.warning("请选择图片")
        return
      }

      if (this.uploadMode !== 0) {
        if (this.myAtlasId !== 0) {
          this.atlasId = this.myAtlasId

          this.choosePic.forEach((e, i) => {
            let picMsg = {
              atlasId: this.atlasId,
              pictureId: e
            }
            this.bindingAtlasAsync(picMsg)
          })

          this.$refs['ruleForm'].resetFields();
          this.isSave = false

          setTimeout(() => {
            this.atlasId = ''
            this.reload()
          }, 1000);
        } else {
          this.$message.warning('请选择图集')
        }
      } else {

        this.$refs[formName].validate(valid => {
          if (valid) {
            this.isSave = true
            this.addAtlasAsync(this.atlasForm)

            // console.log(1)
          } else {
            return false;
          }
        });
      }
    },

    //批量删除
    plDelete () {
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          this.isSave = true
          this.isDelete = true
          for (let i = 0; i < this.choosePic.length; i++) {
            this.deletePictureAsync(this.choosePic[i])
          }

          setTimeout(() => {
            this.allPicList = []
            this.testList = []
            this.testListMonth = []
            this.choosePic = []
            this.nnclutteredPic = 0
            this.listUnclutteredPictureAsync({ uid: this.createUid })
            this.isSave = false
            this.isDelete = false
          }, 1000);
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });

    },



    //排序
    sortClick () {
      this.sortFlag = !this.sortFlag;
      this.page = 0
      if (this.orderByTime === 0) {
        this.orderByTime = 1
      } else {
        this.orderByTime = 0
      }

      let params = {
        createUid: this.createUid,
        keyword: this.selectInput,
        libId: this.picId,
        timeStart: this.timeStart,
        timeEnd: this.timeEnd,
        page: this.page,
        pageSize: this.pageSize,
        orderByTime: this.orderByTime
      };
      this.searchAtlasAsync(params)
    },

    intoPicList (id) {
      this.$router.push({
        name: "piclist", //跳转的路径
        query: {
          //路由传参时push和query搭配使用 ，作用时传递参数
          id: id
        }
      });
    },

    //滚动加载图库和图片
    scrollPic () {
      // let isBottom = (document.documentElement.scrollTop + window.innerHeight) === document.body.offsetHeight

      let isBottom =
        document.documentElement.scrollTop + window.innerHeight + 50 >=
        document.body.offsetHeight;

      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop)
      // this.pic.id = scrollTop
      if (isBottom) {
        // if (this.isPic === 0) {

        // } else if (this.isPic === 1) {
        let allLength = 0
        for (let i = 0; i < this.testList.length; i++) {
          allLength += this.testList[i].picList.length
        }
        if (allLength < this.nnclutteredPic && this.passFlag) {
          this.currentPage++;
          let params = {
            page: this.currentPage
          };
          this.showLoading = true
          setTimeout(() => {
            this.listUnclutteredPictureAsync(params);
          }, 1000);
        }
        // } else if (this.isPic == 2) {

        // }


      }
      if (scrollTop >= 216) {
        this.picinfClass = "picinf picinfpos";
      } else {
        this.picinfClass = "picinf";
      }
    },


    //把接口返回的json转换成数组---按日期
    dealWithData (data) {
      let c = [];
      let d = {};
      data.forEach(element => {
        if (!d[element.mycreateAt]) {
          c.push({
            time420: false,
            indeterminate: false,
            chooseFlag: 0,
            mycreateAt: element.mycreateAt,
            picList: [element]
          });
          d[element.mycreateAt] = element;
        } else {
          c.forEach(ele => {
            if (ele.mycreateAt == element.mycreateAt) {
              ele.picList.push(element);
            }
          });
        }

      });
      return c;
    },

    //把接口返回的json转换成数组---按月份
    dealWithMonth (data) {
      let c = [];
      let d = {};
      data.forEach(element => {
        if (!d[element.mycreateAtMonth]) {
          c.push({
            time420: false,
            indeterminate: false,
            chooseFlag: 0,
            mycreateAtMonth: element.mycreateAtMonth,
            picList: [element]
          });
          d[element.mycreateAtMonth] = element;
        } else {
          c.forEach(ele => {
            if (ele.mycreateAtMonth == element.mycreateAtMonth) {
              ele.picList.push(element);
            }
          });
        }

      });
      return c;
    },


    unclutter () {

      if (this.isPic !== 1) {
        this.nnclutteredPic = 0
        this.testList = []
        this.testListMonth = []
        this.currentPage = 0
        this.listUnclutteredPictureAsync({ page: this.currentPage, uid: this.createUid })
      }

      setTimeout(() => {
        this.isPic = 1
      }, 200);
    },

    async deletePictureAsync (val) {
      await removePicturePic(val)
    },






    //获取未整理图片
    async listUnclutteredPictureAsync (val) {
      let { status, data, message, pagination, errors } = await listUnclutteredPicture(val);
      this.isRefresh = false
      if (status) {
        this.nnclutteredPic = pagination.total
        for (let i = 0; i < data.length; i++) {
          data[i].type='pic'
          if (data[i].createAt !== 0) {
            data[i].mycreateAt = formatConversion(data[i].createAt.toString()).substring(0, 10)
          } else {
            data[i].mycreateAt = '暂无创建时间'
          }
          if (data[i].createAt !== 0) {
            data[i].mycreateAtMonth = formatConversion(data[i].createAt.toString()).substring(0, 7)
          } else {
            data[i].mycreateAtMonth = '暂无创建时间'
          }
          if (data[i].fileInfo) {
            if (data[i].fileInfo.picThumbH160) {
              data[i].src = picPrefix + data[i].fileInfo.picThumbH160
              data[i].picThumbW1080 = picPrefix + data[i].fileInfo.picThumbW1080
            } else {
              data[i].src = picPrefix + data[i].fileInfo.savepath
              data[i].picThumbWh160 = picPrefix + data[i].fileInfo.savepath
              data[i].picThumbW1080 = picPrefix + data[i].fileInfo.savepath
            }
            if (data[i].fileInfo.picThumbH160 === 'error') {
              data[i].src = require('@/assets/house/onloadpic.png')
            }

            let imgTest = new Image()
            imgTest.src = data[i].src
            console.log('imgTest.src',imgTest.src);
            imgTest.onerror = () => {
              data[i].src = require('@/assets/house/onloadpicerror.png')
              data[i].picThumbW1080 = require('@/assets/house/onloadpicerror.png')
            }
          } else {
            data[i].src = require('@/assets/house/onloadpic.png')
            data[i].picThumbW1080 = require('@/assets/house/onloadpic.png')
          }
        }
        // this.testList = this.dealWithData(data)
        // this.testListMonth = this.dealWithMonth(data)


        // if (this.currentPage === 0) {
        //   this.testList = this.dealWithData(data)
        //   this.testListMonth = this.dealWithMonth(data)
        //   this.allPicList = data
        // } else {
          for (let i = 0; i < data.length; i++) {
            this.allPicList.push(data[i])
          }
          this.testList = this.dealWithData(this.allPicList)
          this.testListMonth = this.dealWithMonth(this.allPicList)


          // let date = this.dealWithData(data)
          // for (let i = 0; i < date.length; i++) {
          //   this.testList.push(date[i]);
          // }
          // let month = this.dealWithMonth(data)
          // for (let i = 0; i < month.length; i++) {
          //   this.testListMonth.push(month[i]);
          // }
        // }

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
      this.showLoading = false
      this.passFlag = true
    },

    // 获取未整理视频
    
    async listUnclutteredVideoAsync (val) {
      let { status, data, message, pagination, errors } = await listUnclutteredVideo(val);
      // this.isRefresh = false
      if (status) {
        // this.nnclutteredPic = pagination.total
        for (let i = 0; i < data.length; i++) {
          data[i].type = 'video';
          if (data[i].createAt !== 0) {
            data[i].mycreateAt = formatConversion(data[i].createAt.toString()).substring(0, 10)
          } else {
            data[i].mycreateAt = '暂无创建时间'
          }
          if (data[i].createAt !== 0) {
            data[i].mycreateAtMonth = formatConversion(data[i].createAt.toString()).substring(0, 7)
          } else {
            data[i].mycreateAtMonth = '暂无创建时间'
          }
          if (data[i].fileInfo) {
            if (data[i].fileInfo.encodeSavepath) {
              data[i].src = picPrefix + data[i].fileInfo.encodeSavepath
            } else {
              data[i].src = picPrefix + data[i].fileInfo.savepath
            }
            data[i].savepath = picPrefix + data[i].fileInfo.savepath
            if (data[i].exif) {
            if(data[i].exif.exif){
              let exif = JSON.parse(data[i].exif.exif)
              if(exif.hasOwnProperty('video_cover')){
                data[i].picThumbWh160 = picPrefix + exif.video_cover
              }else{
                data[i].exif.videoCaptureFileIds = data[i].exif.videoCaptureFileIds.split(',')
                if(data[i].exif.videoCaptureFileIds.length > 1){
                  let picInfo = await getFileInfoById(data[i].exif.videoCaptureFileIds[0])
                  if (picInfo.data) {
                    if (picInfo.data.picThumbWh160) {
                      data[i].picThumbWh160 = picPrefix + picInfo.data.picThumbWh160
                    } else {
                      data[i].picThumbWh160 = require('@/assets/house/onloadpic.png')
                    }
                  } else {
                    data[i].picThumbWh160 = require('@/assets/house/onloadpic.png')
                  }
                }
                
              }
            }

            } else {
              data[i].picThumbWh160 = require('@/assets/house/onloadpic.png')
            }
  

          } 
        }
        this.allPicList = data
        this.listUnclutteredPictureAsync({ page: this.currentPage, uid: this.createUid })
      } 
    },

    //创建图集
    async addAtlasAsync (val) {
      let libArr = val.libId
      if(libArr.length >= 2){
        val.parentLibId = parseInt(libArr[0])
        val.libId = parseInt(libArr[1])
      }else{
        val.parentLibId = 0
        val.libId = parseInt(libArr[0])
      }
      let { status, data, message, errors } = await addAtlas(val);
      this.dialogLoading = false
      if (status) {
        // this.$message.success("添加成功！");
        this.atlasId = data.id
        this.libId = data.libId
        this.atlasInfo = data

        // console.log(this.choosePic)

        this.choosePic.forEach((e, i) => {

          let picMsg = {
            atlasId: this.atlasId,
            pictureId: e
          }
          this.bindingAtlasAsync(picMsg)
        })

        this.$refs['ruleForm'].resetFields();
        this.isSave = false

        setTimeout(() => {
          this.reload()
          this.listLibAsync()
          //获取未整理图片
          // this.listUnclutteredPictureAsync({ uid: this.createUid })
          this.listUnclutteredVideoAsync({ uid: this.createUid })
          this.mySearchAtlasAsync({
            pageSize: 60, page: 0, createUid: this.createUid
          })
        }, 1000);
        // this.isPic = 0

        // this.searchAtlasAsync({pageSize:this.pageSize,page:0,orderByTime : this.orderByTime,createUid:this.createUid})

        // this.listUnclutteredPictureAsync({uid:this.createUid})
        // this.$router.push({
        //   name: "piccenter", //跳转的路径
        // });

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }

    },


    //创建图片对象
    async bindingAtlasAsync (val) {
      let { status, data, message, errors } = await bindingAtlas(val);
      if (status) {
        this.uploadMode = 0
        this.nnclutteredPic = []
        this.listUnclutteredPictureAsync({ uid: this.createUid })
        this.atlasId = 0
        this.libId = 0
        this.alreadyPicLength++
        if (this.alreadyPicLength == this.choosePic.length) {
          this.$message.success('添加成功！')
          this.alreadyPicLength = 0
          this.choosePic = []
        }

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },





    //获取图片库列表
    async listLibAsync () {
      let { status, data, message } = await listLib();
      if (status) {
        this.belongPicList = [
          {
            id: 0,
            name: "全部"
          }
        ]
        this.options = []
        if (localStorage.getItem('createUid') == 60000) {
          for (let i = 0; i < data.length; i++) {
            if (data[i].status === 1) {
              this.options.push({
                value: data[i].id,
                label: data[i].name,
                children:[]
              });
              this.belongPicList.push({
                id: data[i].id,
                name: data[i].name
              });
            }


          }

        } else {
          for (let i = 0; i < data.length; i++) {
            if (this.allowLib.indexOf(data[i].id.toString()) !== -1) {
              if (data[i].status === 1) {
                this.options.push({
                  value: data[i].id,
                  label: data[i].name,
                children:[]
                });
                this.belongPicList.push({
                  id: data[i].id,
                  name: data[i].name
                });
              }


            }

          }
        }
        if (this.options.length > 0) {
          this.atlasForm.libId = this.options[0].value
        }
      }
      if (data) {
        this.belongPicList = [
          {
            id: 0,
            name: "全部"
          }
        ]
        this.options = []
        if (localStorage.getItem('createUid') == 60000) {
          for (let i = 0; i < data.length; i++) {
            if (data[i].status === 1) {
              this.options.push({
                value: data[i].id,
                label: data[i].name,
                children:[]
              });
              this.belongPicList.push({
                id: data[i].id,
                name: data[i].name
              });
            }


          }

        } else {
          for (let i = 0; i < data.length; i++) {
            if (this.allowLib.indexOf(data[i].id.toString()) !== -1) {
              if (data[i].status === 1) {
                this.options.push({
                  value: data[i].id,
                  label: data[i].name,
                  children:[]
                });
                this.belongPicList.push({
                  id: data[i].id,
                  name: data[i].name
                });
              }


            }

          }
        }
        if (this.options.length > 0) {
          this.atlasForm.libId = this.options[0].value
        }
      }

      for (let i = 0;i < this.options.length;i++) {
        let flag = 0
          for (let j = 0; j < this.allowLib.length; j++) {
            if(this.allowLib[j].toString().indexOf('-') !== -1){
              if(this.options[i].value == this.allowLib[j].split('-')[0]){
                flag++
                this.options[i].children.push({
                  value: this.allowLib[j].split('-')[1],
                  label: ''
                })
              }
            }
            
          }
          if(flag == 0){
            delete this.options[i].children
          }
      }

      for (let i = 0; i < this.options.length; i++) {
        if(this.options[i].hasOwnProperty('children')){
          if(this.options[i].children.length > 0){
            let spliceNum = []
            for (let z = 0; z < this.options[i].children.length; z++) {
              for (let j = 0; j < data.length; j++) {
                if(data[j].id == this.options[i].children[z].value){
                  if(data[j].status === 1){
                    this.options[i].children[z].label = data[j].name
                  }else{
                    spliceNum.push(z)
                  }
                }
                
              }
              
            }
            
            for (let index = 0; index < spliceNum.length; index++) {
              this.options[i].children.splice(spliceNum[index] - index,1)
            }
            
            if(this.options[i].children.length == 0){
              delete this.options[i]
            }
          }
        }
        
        
      }
    },

    //判断分辨率
    judgRes () {
      if (this.isAside && this.displayResolution > 1700) {
        this.atlasMargin = "16px"
      } else if (this.isAside && this.displayResolution < 1700) {
        this.atlasMargin = "38px"
      } else if (!this.isAside && this.displayResolution > 1700) {
        this.atlasMargin = "45px"
      } else if (!this.isAside && this.displayResolution < 1700) {
        this.atlasMargin = "75px"
      }
    },

    //判断gril的row值
    checkRow () {
      this.displayResolution = document.documentElement.clientWidth;
      if (this.displayResolution > 2800) {
        this.row = 9
        this.widthWithUP = "13%"
        this.faceRow = 8
        this.widthWithUPFace = '23.5%'
      } else
        if (this.displayResolution > 2700) {
          this.row = 8
          this.widthWithUP = "13%"
          this.faceRow = 7
          this.widthWithUPFace = '23.5%'
        } else
          if (this.displayResolution > 2500) {
            this.row = 7
            this.widthWithUP = "13%"
            this.faceRow = 6
            this.widthWithUPFace = '23.5%'
          } else
            if (this.displayResolution > 2400) {
              this.row = 6
              this.widthWithUP = "14%"
              this.faceRow = 5
              this.widthWithUPFace = '23.5%'
            } else
              if (this.displayResolution > 2000) {
                this.row = 5
                this.widthWithUP = "16%"
                this.faceRow = 4
                this.widthWithUPFace = '23.5%'
              } else

                if (this.displayResolution > 1700) {
                  this.row = 5
                  this.widthWithUP = "18%"
                  this.faceRow = 4
                  this.widthWithUPFace = '23.5%'
                }
      if (this.displayResolution <= 1700) {
        this.row = 4
        this.widthWithUP = "21.5%"
        this.faceRow = 3
        this.widthWithUPFace = '25%'
      }
      if (this.displayResolution <= 1600) {
        this.row = 4
        this.widthWithUP = "22.5%"
        this.faceRow = 3
        this.widthWithUPFace = '25%'
      }
      if (this.displayResolution <= 1550) {
        this.row = 3
        this.widthWithUP = "22.5%"
        this.faceRow = 3
        this.widthWithUPFace = '25%'
      }
      if (this.displayResolution <= 1400) {
        this.row = 3
        this.widthWithUP = "25%"
        this.faceRow = 2
        this.widthWithUPFace = '25%'
      }
    }





  },
  created () {
    this.isRefresh = true


    // console.log(this.isReLoad)

    this.atlasForm.status = this.visibilityList[1].value

    let createLength = 0

    if (powersObj.createPrivateAtlas) {
      this.statusFlag = true
      this.atlasForm.status = '0'
    } else {
      createLength++
    }
    if (powersObj.createPublicAtlas) {
      this.statusFlag = true
      this.atlasForm.status = '1'
    } else {
      createLength++
    }

    if (createLength == 2) {
      this.isSave = true
      this.statusFlag = true
      this.$message.warning('请联系管理员添加可见性的权限！')
    }

    if (createLength == 0) {
      this.statusFlag = false
      this.atlasForm.status = '0'
    }


    //获取未整理图片
    // this.listUnclutteredPictureAsync({ uid: this.createUid })
    this.listUnclutteredVideoAsync({ uid: this.createUid })

    //获取图库列表
    this.listLibAsync()


    //获取个人图集列表
    this.mySearchAtlasAsync({
      pageSize: 60, page: 0, createUid: this.createUid
    })

    this.displayResolution = document.documentElement.clientWidth;

    this.documentHeight = document.documentElement.clientHeight

    if (this.documentHeight <= 650) {
      this.minRows = 0
      this.maxRows = 1
    } else if (this.documentHeight <= 775) {
      this.minRows = 4
      this.maxRows = 8
    } else if (this.documentHeight <= 970) {
      this.minRows = 8
      this.maxRows = 12
    }

    setInterval(() => {
      this.judgRes()
    }, 888);



  },
  mounted () {
    window.addEventListener("scroll", this.scrollPic);
    //获取侧边栏是否收起
    this.bus.$on('changeIsaside', (message) => {
      this.bus.val = message
      this.isAside = this.bus.val
      // this.isChildren = false
    })
  },
  destroyed () {
    //离开这个界面之后，删除，不然会有问题
    window.removeEventListener("scroll", this.scrollPic);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./nnclutteredPic.scss";

/*滚动条样式*/
::v-deep ::-webkit-scrollbar {
  width: 10px;
  /*height: 4px;*/
}
::v-deep ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
::v-deep ::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
}

.el-table ::v-deep .el-table__body tr td {
  cursor: pointer;
}
.el-table ::v-deep .el-table__body .current-row td {
  background-color: #929292 !important;
}
.el-table ::v-deep .el-table__body .current-row td .cell {
  color: #fff !important;
}

// .el-radio-group ::v-deep .is-active .el-radio-button__inner {
//   background: #185ed3;
//   border-color: #185ed3;
// }
.seeInfo {
  background: #f2f2f2 !important;
  border: 1px solid rgba(119, 119, 119, 0.1);
  color: #333333;
  margin-right: -40px;
}

::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #3CB035;
  border-color: #3CB035;
}
</style>
